"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_RULESET_RESULTS = exports.UPDATE_CONFIG = exports.RUN_PRE_SUBMIT_ACTIONS = exports.RESET_FIELDS = exports.RESET_CHILD_FORM = exports.TRIGGER_EVENT = exports.EXTERNAL_MODEL_UPDATE = exports.RUN_UPDATES = exports.UPDATE_VALUE_AND_RUN = exports.SET_ACTIVE_FORM = exports.REMOVE_FORM = exports.LOAD_NEW_FORMS = exports.rexPrefix = exports.MODEL_TYPE = exports.MODEL_CONTENTS = void 0;
exports.MODEL_CONTENTS = '__CONTENTS__';
exports.MODEL_TYPE = '__TYPE__';
const PREFIX = 'rex/';
const rexPrefix = constant => `${PREFIX}${constant}`;
exports.rexPrefix = rexPrefix;
exports.LOAD_NEW_FORMS = (0, exports.rexPrefix)('LOAD_NEW_FORMS');
exports.REMOVE_FORM = (0, exports.rexPrefix)('REMOVE_FORM');
exports.SET_ACTIVE_FORM = (0, exports.rexPrefix)('SET_ACTIVE_FORM');
exports.UPDATE_VALUE_AND_RUN = (0, exports.rexPrefix)('UPDATE_VALUE_AND_RUN');
exports.RUN_UPDATES = (0, exports.rexPrefix)('RUN_UPDATES');
exports.EXTERNAL_MODEL_UPDATE = (0, exports.rexPrefix)('EXTERNAL_MODEL_UPDATE');
exports.TRIGGER_EVENT = (0, exports.rexPrefix)('TRIGGER_EVENT');
exports.RESET_CHILD_FORM = (0, exports.rexPrefix)('RESET_CHILD_FORM');
exports.RESET_FIELDS = (0, exports.rexPrefix)('RESET_FIELDS');
exports.RUN_PRE_SUBMIT_ACTIONS = (0, exports.rexPrefix)('RUN_PRE_SUBMIT_ACTIONS');
exports.UPDATE_CONFIG = (0, exports.rexPrefix)('UPDATE_CONFIG');
exports.UPDATE_RULESET_RESULTS = (0, exports.rexPrefix)('UPDATE_RULESET_RESULTS');
//# sourceMappingURL=constants.js.map